module.exports = __webpack_public_path__ + "static/img/i9.1024a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i9.png
// module id = ltXf
// module chunks = 0